import instance from '@apis/instance';
import { GiftCategoryRow } from '@models/gift';

class GiftCategoryApi {
    static getGiftCategories(): Promise<GiftCategoryRow[]> {
        return instance.get('/v0/gift-categories');
    }
}

export default GiftCategoryApi;
